/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc
 */
import * as References from './MarketplaceStorefrontPublicRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc#getSearchFilterConfig
 */
export const GET_SEARCH_FILTER_CONFIG_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_storefront_service_rpc_MarketplaceStorefrontPublicRpc_getSearchFilterConfig';
export const GET_SEARCH_FILTER_CONFIG_QUERY: RegisteredQuery<
  'result',
  References.GetSearchFilterConfigRequestType,
  References.GetSearchFilterConfigResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SEARCH_FILTER_CONFIG_QUERY_FIELD_NAME,
  args: ['language', 'productTypes', 'includeWorkflowTemplates'],
  fetcher(
    request: References.GetSearchFilterConfigRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSearchFilterConfigResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSearchFilterConfigRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc#getPaginatedSearchFilterOptions
 */
export const GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_storefront_service_rpc_MarketplaceStorefrontPublicRpc_getPaginatedSearchFilterOptions';
export const GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY: RegisteredQuery<
  'result',
  References.GetPaginatedSearchFilterOptionsRequestType,
  References.GetPaginatedSearchFilterOptionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY_FIELD_NAME,
  args: ['field', 'page', 'search', 'language'],
  fetcher(
    request: References.GetPaginatedSearchFilterOptionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPaginatedSearchFilterOptionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPaginatedSearchFilterOptionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc#getBatchSearchFilterOptions
 */
export const GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_storefront_service_rpc_MarketplaceStorefrontPublicRpc_getBatchSearchFilterOptions';
export const GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY: RegisteredQuery<
  'result',
  References.GetBatchSearchFilterOptionsRequestType,
  References.GetBatchSearchFilterOptionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY_FIELD_NAME,
  args: ['filters', 'includeHelpText', 'language'],
  fetcher(
    request: References.GetBatchSearchFilterOptionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetBatchSearchFilterOptionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getBatchSearchFilterOptionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
